import api from "./api";
import { waLink } from "./messages";
import { toast } from "sonner";

// Usta ekranında müşteri numarası maskeli olabilir (phone_masked). Gerekirse sunucudan, kayıt altına alınarak istenir.
export async function resolvePhone(job) {
  if (!job.phone_masked) return { phone: job.customer_phone };
  try { return { phone: (await api.post(`/jobs/${job.id}/reveal-phone`)).data.phone }; }
  catch (e) { if (e.response?.status === 403) return { bridge: true }; throw e; }
}

export async function callCustomer(job) {
  try {
    if (!job.phone_masked) { window.location.href = `tel:${job.customer_phone}`; return; }
    const { data } = await api.post(`/jobs/${job.id}/call`);
    if (data.tel) window.location.href = `tel:${data.tel}`; else toast.success(data.message || "Arama başlatıldı");
  } catch (e) { toast.error(e.response?.data?.detail || "Arama başlatılamadı"); }
}

// WhatsApp'ta aç (numara serbestse / maskeliyse kayıtlı açılışla) ya da köprü modunda sunucu üzerinden gönder
export async function shareToCustomer(job, text) {
  try {
    const r = await resolvePhone(job);
    if (r.phone) { window.open(waLink(r.phone, text), "_blank"); return "wa"; }
    await api.post(`/jobs/${job.id}/message`, { text });
    toast.success("Mesaj müşteriye gönderildi");
    return "server";
  } catch (e) { toast.error(e.response?.data?.detail || "Mesaj gönderilemedi"); return null; }
}
